import {t} from "../../i18n";
import {bindInputListeners, bindPasswordToggles, bindPhoneValidation, showValidationErrors, reportRequestError} from "../../utils/formHelpers";
import {bwMarketingBase} from "../../utils/baseUrl.js";
import {renderCountrySelect, pickDefaultCountry, bindCountryPicker} from "../../utils/phoneCountries.js";

export default function authRegister({ $, api, state, data, routes, emit, sharedState, onNext, onComplete, onSaveState }) {
    function render() {
        const $el = $(`
    <div class="booking-register-row active" data-auth-step="booking-register">
        <button class='login-close-button'>&times;</button>
        <h3>${t('create_an_account')}</h3>
        <p>${t('almost_done')}</p>
        <form class="booking-register-form">
            <div class="form-row">
                <label for="bookingRegisterName">${t('full_name')}</label>
                <input required type='text' id="bookingRegisterName" name="name"/>
            </div>
            <div class="form-row">
                <label for="bookingRegisterPhone">${t('phone')}</label>
                <div class="phone-row">
                    ${renderCountrySelect({id: 'bookingRegisterPhoneCountry', selected: pickDefaultCountry(data, sharedState)})}
                    <input required type="tel" inputmode="tel" autocomplete="tel" id="bookingRegisterPhone" name="phone"/>
                </div>
                <p class="field-error field-phone-error" style="display:none;">
                    ${t('form.please_enter_a_valid_number')}
                </p>
                <p class="field-error field-phone-invalid-error" style="display:none;">
                    ${t('phone_invalid_sms')}
                </p>
            </div>
            <div class="form-row">
                <label for="bookingRegisterEmail">${t('email')}</label>
                <input required type='email' id="bookingRegisterEmail" name="email"/>
            </div>
            <div class="form-row">
                <label for="bookingRegisterConfirmEmail">${t('confirm_email_address')}</label>
                <input required type='email' id="bookingRegisterConfirmEmail" name="email_confirmation"/>
                <p class="field-error field-email-error" style="display:none;">${t('emails_do_not_match')}</p>
            </div>
            <div class="form-row">
                <label for="bookingRegisterPassword">${t('password')}</label>
                <input required type='password' id="bookingRegisterPassword" name="password"/>
                <p class="field-error field-password-length-error" style="display:none;">${t('password_must_have_at_least_6_characters')}</p>
            </div>
            <div class="form-row form-policies">
                <div>
                    <input required="" type="checkbox" id="bookingRegisterPolicies">
                    <label for="bookingRegisterPolicies">
                        ${t('agree_with_the')}
                        <a href="${bwMarketingBase()}/politica-de-confidentialitate" target="_blank">${t('privacy_policy')}</a>,
                        <a href="${bwMarketingBase()}/gdpr" target="_blank">${t('terms_of_use')}</a>
                        ${t('and')}
                        <a href="${bwMarketingBase()}/termeni-si-conditii" target="_blank">${t('terms_of_services')}</a>
                    </label>
                </div>
                <div>
                    <input type="checkbox" id="bookingRegisterNews">
                    <label for="bookingRegisterNews">
                        ${t('i_wani_ti_receivi_marketini_stuff')}
                    </label>
                </div>
                <div class="error-messages"></div>
                <div class="form-actions">
                    <button type="submit">${t('continue')}</button>
                </div>
            </div>
        </form>
    </div>
    `);

        $el.find("#bookingRegisterEmail").val(sharedState.email);

        $el.on('submit', '.booking-register-form', e => {
            e.preventDefault();

            let name =          $el.find("#bookingRegisterName").val();
            let phone =         $el.find("#bookingRegisterPhone").val().trim().replace(/[^\d+]/g, '');
            let phoneCountry =  $el.find("#bookingRegisterPhoneCountry").val();
            let email =         $el.find("#bookingRegisterEmail").val();
            let confirmEmail =  $el.find("#bookingRegisterConfirmEmail").val();
            let password =      $el.find("#bookingRegisterPassword").val();
            let wantsNews =     $el.find("#bookingRegisterNews").prop("checked");
            // Shows its own message under the field; a code is always sent after register.
            const phoneOk =     validatePhone(true);

            if(phoneOk && email === confirmEmail && password.length >= 6) {
                // save phone and email for next steps
                sharedState.phone = phone;
                sharedState.phoneCountry = phoneCountry;
                sharedState.email = email;

                api.post(routes.webRegister, {
                    data: {
                        name: name,
                        email: email,
                        password: password,
                        phone: phone,
                        // the picker: parse country for a prefix-less number (App\Support\Phone::COUNTRY_FIELD)
                        phone_country: phoneCountry,
                        wantsNews: wantsNews
                    },
                    success: (res) => {
                        // Register does NOT log in: the server logs the account in only when the SMS
                        // code comes back (validateCode). Until then the widget is the only place that
                        // knows who this is - keep it, the way the home page keeps user_id in
                        // localStorage. Without it, the close button on the SMS step -> phone step ->
                        // validatePhone 404 -> guest code -> Finalize without a name = "Fara cont"
                        // (dollieskin, 2026-09-29).
                        const id = res && res.id ? res.id : null;
                        // The server stores the NORMALIZED phone and keys the SMS code on it; the raw
                        // input ("0040...") would never match either lookup.
                        const savedPhone = (res && res.phone) ? String(res.phone) : phone;
                        sharedState.phone = savedPhone;
                        sharedState.registeredId = id;
                        // A "continue without account" chosen earlier on this page no longer applies:
                        // left set, the code check would skip the account and thanks.js would show
                        // the guest ending to someone who has just created one.
                        delete sharedState.noAccount;
                        data.user = {...(data.user || {}), id, name, email, phone: savedPhone};
                        if (name && name.trim()) {
                            state.bookingName = name.trim();
                        }
                        onNext('booking-sms')
                    },
                    // 502-ul din 9 sept 2026 (healthlife) a fost mut aici: status fără JSON → {} → nimic.
                    error: (err) => reportRequestError($el, err, 'register')
                })
            } else {
                const errors = {}
                // $el.find(".error-messages").empty();
                if (email !== confirmEmail) {
                    // $el.find(".error-messages").append(`<p class="error">${t('emails_do_not_match')}</p>`);
                    errors.email_confirmation = t('emails_do_not_match');
                }
                if (password.length < 6) {
                    // $el.find(".error-messages").append(`<p class="error">${t('password_must_have_at_least_6_characters')}</p>`);
                    errors.password = t('password_must_have_at_least_6_characters');
                }
                showValidationErrors($el, errors || {});
            }
        })

        bindInputListeners($el);
        bindPasswordToggles($el); // FB-031
        bindCountryPicker($el.find('#bookingRegisterPhone'), $el.find('#bookingRegisterPhoneCountry'));
        const validatePhone = bindPhoneValidation($el.find('#bookingRegisterPhone'), {
            withCountryPicker: true,
            $country: $el.find('#bookingRegisterPhoneCountry')
        });

        return $el;
    }

    return { render };
}